class SaleWindow extends HTMLElement {
  connectedCallback() {
    this.release = (parseInt(this.dataset.release, 10) || 0) * 1000;
    this.end = (parseInt(this.dataset.end, 10) || 0) * 1000;
    this.states = {};
    this.querySelectorAll('[data-sale-state]').forEach((el) => {
      this.states[el.dataset.saleState] = el;
    });

    this.update();
    this.schedule(this.release);
    this.schedule(this.end);
  }

  update() {
    const now = Date.now();
    let current;
    if (this.release > 0 && now < this.release) {
      current = 'before';
    } else if (this.end > 0 && now >= this.end) {
      current = 'after';
    } else {
      current = 'active';
    }
    Object.entries(this.states).forEach(([state, el]) => {
      el.hidden = state !== current;
    });
  }

  schedule(target) {
    if (!target) return;
    const delay = target - Date.now() + 50;
    if (delay <= 0 || delay > 2147483000) return;
    setTimeout(() => this.update(), delay);
  }
}

if (!customElements.get('sale-window')) {
  customElements.define('sale-window', SaleWindow);
}
